import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import i18n from "i18next";

import { formatAddressToSummary } from "../../helpers/addressHelpers";
import { formatDate } from "../../helpers/dateHelpers";
import { formatInvoice } from "../../helpers/invoiceHelpers";
import { formatShipmentStatus } from "./../../helpers/shipmentStatusHelpers";
import { formatVehicle } from "../../helpers/vehicleHelpers";
import Button from "./../Common/Button";
import PanelHeaderSummary from "./../Layout/Panel/PanelHeaderSummary";
import PanelHeaderSummaryInfo from "./../Layout/Panel/PanelHeaderSummaryInfo";

export default class SummaryMobile extends PureComponent {
  static propTypes = {
    load: PropTypes.object.isRequired,
    selectedBillOfLading: PropTypes.object.isRequired,
    userMetadata: PropTypes.object.isRequired,
    isSummaryOpen: PropTypes.bool,
    summaryButtonClick: PropTypes.func
  };

  static defaultProps = { isSummaryOpen: false, summaryButtonClick: null };

  handleRoutingButton = () => {};

  render() {
    const { selectedBillOfLading, isSummaryOpen, load, summaryButtonClick, userMetadata } = this.props;
    const { soldTo = {}, careOf = {}, ultimateConsignee = {}, millOfOrigin = {}, invoices = {} } = selectedBillOfLading;

    return (
      <PanelHeaderSummary isSummaryOpen={isSummaryOpen}>
        <div className="panel-summary__section-row-container">
          <div className="panel-summary__section-row">
            <PanelHeaderSummaryInfo label={i18n.t("billsOfLading.invoice")} value={formatInvoice(invoices)} className="--flex-2" />
          </div>
          <div className="panel-summary__section-column-mobile">
            <PanelHeaderSummaryInfo label={i18n.t("billsOfLading.shippedFrom")} value={millOfOrigin.locationName} className="--flex-2" />
            <PanelHeaderSummaryInfo label={i18n.t("billsOfLading.careOf")} value={careOf.locationName} />
            <PanelHeaderSummaryInfo label={i18n.t("billsOfLading.modeOfTransport")} value={selectedBillOfLading.modeOfTransport} />
            <PanelHeaderSummaryInfo
              label={i18n.t("billsOfLading.soldTo")}
              customValue={formatAddressToSummary(soldTo.customerAddress, soldTo.customerName)}
              className="--flex-2"
            />
            <PanelHeaderSummaryInfo
              label={i18n.t("billsOfLading.ultimateConsignee")}
              customValue={formatAddressToSummary(ultimateConsignee.customerAddress, ultimateConsignee.customerName)}
              className="--flex-2"
            />
            <PanelHeaderSummaryInfo label={i18n.t("billsOfLading.endUser")} value={selectedBillOfLading.endUserId} />
            <PanelHeaderSummaryInfo label={i18n.t("billsOfLading.carrier")} value={selectedBillOfLading.carrierName} />
            <PanelHeaderSummaryInfo label={i18n.t("billsOfLading.vehicle")} value={formatVehicle(selectedBillOfLading)} />
            <PanelHeaderSummaryInfo
              label={i18n.t("billsOfLading.shippedDate")}
              value={formatDate(selectedBillOfLading.shippedDate, userMetadata.dateDisplayFormat)}
            />
            <PanelHeaderSummaryInfo
              label={i18n.t("billsOfLading.shipmentStatus")}
              value={formatShipmentStatus(load.loadShipmentStatus, userMetadata.dateDisplayFormat)}
            />
          </div>
        </div>

        <Button className="panel-summary__close-button" icon="arrow-up-flat" onClick={summaryButtonClick} />
      </PanelHeaderSummary>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BillOfLading/SummaryMobile.js